module.exports = __webpack_public_path__ + "img/bijiu-logo2.52c337dc.png";